/**
 * Getters for chat
 */
export const getters = {
  getIsGroup(state) {
    return state.isGroup;
  },
  getcurrentSelectedNew(state) {
    return state.currentSelectedNew;
  },
  getMessages(state) {
    return state.messages;
  },
  getGroupMessages(state) {
    return state.groupMessage;
  },
  getPages(state) {
    return state.pages;
  },
  getLastPage(state) {
    return state.lastPage;
  },
  getAdditionalOffset(state) {
    return state.additionalOffset;
  },
  getLoadingMessage(state) {
    return state.loadingMessage;
  },
  getLoadedMessagesOfUsers(state) {
    return state.loadedMessagesOfUsers;
  },
  getLoadedMessagesOfGroups(state) {
    return state.loadedMessagesOfGroups;
  },
  getSelectedUserId(state) {
    return state.selectedUserId;
  },
  getSendingMessage(state) {
    return state.sendingMessage;
  },
  getSendingGroupMessage(state) {
    return state.sendingGroupMessage;
  },
  getName(state) {
    return {
      firstName: state.firstName,
      middleName: state.middleName,
      lastName: state.lastName,
      namePrefix: state.namePrefix,
      nameSuffix: state.nameSuffix
    };
  },
  getFriends(state) {
    return state.friends;
  },
  getGroups(state) {
    return state.groups;
  }
};
